// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl-module__BuildControl__24Xqp","Label":"BuildControl-module__Label__4UCSK","Less":"BuildControl-module__Less___a7vT","More":"BuildControl-module__More__3Uvh5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControl/BuildControl.module.css
// module id = 110
// module chunks = 2